import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';
import { MatTableDataSource } from '@angular/material/table';
import {  MatPaginator } from '@angular/material/paginator';
import { startWith, delay, tap, filter, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { fromEvent } from 'rxjs';
import { AppAnalysisService} from '../../app-analysis-module/app-analysis.service';
import { Globals } from 'src/app/globals';
import { ShareMapService } from '../share-map.service'


@Component({
  selector: 'app-business-user-dashboard',
  templateUrl: './business-user-dashboard.component.html',
  styleUrls: ['./business-user-dashboard.component.css']
})
export class BusinessUserDashboardComponent implements OnInit {
  userName: string;
  isLoggedIn: boolean;

  displayedColumns: string[] = ['map_name','share_mode','shared_on'];
  @ViewChild('dataTableSearchInput') dataTableSearchInput: ElementRef;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  filterValue = "";
  length: any;
  pageSize: any;
  pageEvent: Event;
  shareMaplist:any;

  constructor(private authenticationService: AuthService,
    private AppAnalysisService:AppAnalysisService,
    private ShareMapService:ShareMapService,
    private activatedRoute: ActivatedRoute) {
    this.pageSize = Globals.pageSize
    authenticationService.getLoggedInName.subscribe(name => this.changeName(name));
}
private changeName(name: string): void {
  this.userName = name;
}
  ngOnInit() {
    this.isLoggedIn = this.authenticationService.isAuthenticated();

    if(this.isLoggedIn){
      if(localStorage.length>0){
        this.userName = this.authenticationService.getUserName()
      }
    }
    
    this.authenticationService.isLoggedIn.subscribe((data)=>{
      this.isLoggedIn = this.authenticationService.isAuthenticated();
    })
  }
  ngAfterViewInit(){
    this.paginator.page.pipe(
      startWith(null),
      delay(0),
      tap(()=> {
          this.getShareMaplist();
        })

    ).subscribe()

    fromEvent(this.dataTableSearchInput.nativeElement,'keyup')
    .pipe(
        filter(Boolean),
        debounceTime(1000),
        distinctUntilChanged(),
        tap((text) => {
          console.log(" ------- ",this.dataTableSearchInput.nativeElement.value)
          this.filterValue = this.dataTableSearchInput.nativeElement.value;
          this.getShareMaplist();
        })
    )
    .subscribe();
  }
  getShareMaplist(){
    this.ShareMapService.getSharedMaps(this.paginator.pageIndex,this.filterValue.trim().toLowerCase()).subscribe(
        data => {
          this.length = data.data.count;
          this.shareMaplist = new MatTableDataSource(data.data.data); 
          console.log('list mamber --111',this.length);
      },
      error => {
          console.log(error);
        });
  }
  
  logout(event: Event) {
    console.log("Click!", event);
    this.authenticationService.logout();
    // window.location.reload();
  }
}

